module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAA/ElEQVRIie3VMU7DMBSA4f85GVhQalImCBfgCh1YERsSV8gKR4GRIyAk1qyVysIBuADt1lpuYGEgeWyoQoo64BiB8o9+lj/JHgxDQ/8tWdb1majeghwEOG5hRMu9LKu27lytX+eghz9Hv5qPR9nRtk1pYBSg6Bo45wpN0jsVmjQw2plzb8eatBVQiIKJgS69P9GkfWTjNnqHV96fi5gKGG2u9wo7X18i5h7Y+T7r9Y1VuO6aRXnjAe4dFuUKaKPDuc1u0PYCeI8KA4ytfVBtT4F1VBhg39qpNGYCvESFAfJ891majwnwJMLs175FY0RLkEUoVIQy0FlDQ3+sT8TISh3Wd1RRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/videocall.png
// module id = 890
// module chunks = 0